import React, { Component } from 'react';
import { Card, CardImg, CardBody, CardTitle, CardSubtitle, CardText } from 'reactstrap';

export class ContactCardItem extends Component {
  
  constructor(props) {
    super(props);
    
    console.log("Contact Card", this.props);
    
    try {
      this.title = this.props.title.rendered;
    } catch(e){}
  
    try {
      this.subtitle = this.props.subtitle.rendered;
    } catch(e){}
  
    try {
      this.position = this.props.acf.sphnx_contact_position;
    } catch(e){}
  
    try {
      this.email = this.props.acf.sphnx_contact_email;
    } catch(e){}
  
    try {
      this.phone = this.props.acf.sphnx_contact_phone;
    } catch(e){}
    
  
    try {
      this.contactImage = this.props._embedded["wp:featuredmedia"][0].source_url;
    } catch(e){}
  }
  

  render() {
    
    return (
      <Card className={"card-item contact-card-item p-3" }>
        <CardImg top width="100%" src={this.contactImage || require('../../assets/images/empty.png')} alt="Card image cap" />
        <CardBody>
          <CardTitle>{ this.title }</CardTitle>
          <CardSubtitle>{ this.position }</CardSubtitle>
          <CardText>{ this.phone }</CardText>
          <a href={"mailto:" + this.email }>{ this.email }</a>
      </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/item/ContactCardItem.js